import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsFormBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsFormBlockEntity
